// COACH in production, and the local Demo tenant for development. Mirrors PwiWidget::ALLOWED_TENANT_IDS.
export const PWI_TENANT_IDS = ['61632a03-8f87-49fd-beb5-a94a2b96e6a9', '67153ac5-c67b-4811-9bff-dadc48dc57bb'];

export type PwiBand = 'normal' | 'challenged' | 'high-risk';

export type PwiStage = {
  stage: number;
  label: string;
  surveys: number;
  index: number | null;
  band: PwiBand | null;
};

export type PwiImprovement = { sixMonth: number | null; closure: number | null; overall: number | null };

export type PwiQuestionStage = {
  total: number;
  answers: number;
  min: number | null;
  max: number | null;
  average: number | null;
};

export type PwiQuestion = {
  label: string;
  role: 'index' | 'separate';
  averages: Array<number | null>;
  stages: PwiQuestionStage[];
};

export type PwiSummary = {
  stages: PwiStage[];
  improvement: PwiImprovement;
};

export type PwiResults = PwiSummary & {
  configured: boolean;
  rollup: boolean;
  questions: PwiQuestion[];
  subAccounts: Array<PwiSummary & { name: string; questions: PwiQuestion[] }>;
  notReporting: string[];
};

export const parsePwiResults = (raw: string): PwiResults | null => {
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};
